export enum ReportingContextMenuType {
    fields = "fields",
    groups = "groups",
    filters = "filters",
    constraints = "constraints",
    subGroups = "subGroups",
}

export const ReportingContextMenuTypeValues = [
    ReportingContextMenuType.fields,
    ReportingContextMenuType.groups,
    ReportingContextMenuType.filters,
    ReportingContextMenuType.constraints,
    ReportingContextMenuType.subGroups,
];
